/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyContactDto } from '../../models/agency-contact-dto';

export interface ApiAgencycontactGet$Params {
  'api-version'?: string;
}

export function apiAgencycontactGet(http: HttpClient, rootUrl: string, params?: ApiAgencycontactGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyContactDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAgencycontactGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgencyContactDto>>;
    })
  );
}

apiAgencycontactGet.PATH = '/api/agencycontact';
